import * as React from 'react';
import { SentryLogger } from '../../services/SentryLogger';
import s from './mobile/ErrorBoundaries.scss';
import { FedopsLogger } from '../../services/FedopsLogger';
import { MobileErrorBoundary } from './mobile/MobileErrorBoundary';
import { DesktopErrorBoundary } from './DesktopErrorBoundary';

export class GlobalErrorBoundary extends React.Component<
  { fedopsLogger: FedopsLogger; isMobile: boolean },
  { hasError: boolean }
> {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
    const { fedopsLogger } = this.props;
    fedopsLogger.appLoaded();
    fedopsLogger.beginAppRenderedInteraction();
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch() {
    SentryLogger.logAppCrash();
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className={s.errorBoundary}>
          <div className={s.antena}></div>
          {this.props.isMobile ? (
            <MobileErrorBoundary />
          ) : (
            <DesktopErrorBoundary />
          )}
        </div>
      );
    }

    return this.props.children;
  }
}
